import * as React from 'react';
import classNames from 'classnames';
import AntButton from 'antd/lib/button';
import { ButtonProps as AntButtonProps } from 'antd/lib/button/button';
import { ThemeContext } from 'app-themes';

import styles from './Button.module.scss';

export interface ButtonProps extends AntButtonProps {
	subType?: 'approve' | 'reject' | 'simpleLink';
	isLink?: boolean;
}

class Button extends React.Component<ButtonProps> {
	static contextType = ThemeContext;

	render() {
		const props = this.props;
		const { className, subType, isLink, ...restProps } = props;

		const theme = this.context;

		return (
			<AntButton
				className={classNames(styles.btn, className, {
					[styles.link]: Boolean(props.isLink),
					[styles.simpleLink]: props.subType === 'simpleLink',
					[styles.large]: props.size === 'large',
					[styles.primary]: props.type === 'primary',
					[styles.dashed]: props.type === 'dashed',
					[styles.approve]: props.subType === 'approve',
					[styles.reject]: props.subType === 'reject',
					[styles.small]: props.size === 'small',
					[styles.btnIcon]: Boolean(props.icon),
					[styles.disabled]: Boolean(props.disabled),
					[styles[`btn-${theme}`]]: theme !== '',
				})}
				{...restProps}
			>
				{/*
					Button wraps each element in `children` with `<span />`.
					The display value of a FLEX item is blockified: if the specified display of an
					in-flow child of an element generating a flex container is an inline-level
					value, it computes to its block-level
					Inline behaviour is preserved when wrapping children in one single block
				*/}
				{props.children && <span>{props.children}</span>}
			</AntButton>
		);
	}
}

export default Button;
